module.exports = __webpack_public_path__ + "static/media/icon_insert_setting_chart.767c2574.svg";